import { useContext } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { IoChevronBackOutline } from "react-icons/io5"
import { 
    AppLabel, AppSpan, AppText, Button, CustomContainer, FixedContainer, 
    FlexColumn, FlexRow, GridContainer 
} from "src/style"
import {ReactComponent as ConfirmIcon} from 'src/assets/img/confirm.svg'

export const DisputeDetails: React.FC<any> = ({toggleTo, data}) => {
    const {responder} = useContext(VisibilityContext)

    function handleResolve () {
        responder.show(
            'Dispute resolved', 
            'This dispute has been marked as resolved.', 
            <ConfirmIcon/>, 
            'Continue',
            toggleTo('disputes')
        )
    }

    return (
        <>
            <FixedContainer left="23" top="5.7" zIndex="2" width="100" sizeUnit="%" bgColor="#ffffff" className="subheader-fix-position">
                <GridContainer height="5" leftPadding="2" rightPadding="2" 
                    style={{borderBottom: '1px solid #E2E8F0'}}
                >
                    <FlexRow justifyContent="space-between">
                        <FlexRow width="auto" sizeUnit="">
                            <GridContainer 
                                height='3' width='3.2' borderColor=' #E4ECF7' 
                                radius='0.4' rightMargin='2'
                                onClick={() => toggleTo('disputes')}
                            >
                                <IoChevronBackOutline className='back-icon' />
                            </GridContainer>
                            <AppLabel fontWeight="600" color="#031849" topMargin="0.5">Dispute Case - {data?.caseId}</AppLabel>
                        </FlexRow>
                        <AppText textSize="1.2" fontWeight="600" color="#27272E">Ticket ID: #{data?.id}</AppText>
                    </FlexRow>
                </GridContainer>
            </FixedContainer>
            <GridContainer topMargin="10" bottomMargin="5">
                <FlexColumn 
                    width="66.7" minHeight="75.1" borderColor="#E2E8F0" 
                    radius="0.8" padding="4" justifyContent="space-between"
                >
                    <CustomContainer>
                        <CustomContainer>
                            <AppLabel textSize="2" fontWeight="600" color="#27272E">Dispute information</AppLabel>
                            <AppText textSize="1.6" color="#6F767C" topMargin="0.3">
                                All you need to know about this dispute.
                            </AppText>
                        </CustomContainer>
                        <FlexRow gap="3.5" topMargin="4" wrap="wrap">
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Customer name</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.customerName}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Customer email</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.customerEmail}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Dispute ID</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.caseId}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Dispute created by</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.opennedBy}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Assigned to</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.assignedTo}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Department</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.department}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">Dispute topic</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.title}</AppText>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.6" color="#8492A6">Priority level</AppLabel>
                                <FlexRow>
                                    <CustomContainer 
                                        bgColor={data?.priority === 'Low' ? '#4AAE8C' : data?.priority === 'Medium' ? '#F7936F' : '#F16063'}
                                        radius="0.1" height='1.6' width='1.6' rightMargin='1'
                                    />
                                    <AppText textSize='1.6'>{data?.priority}</AppText>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer width="17">
                                <AppLabel textSize="1.4" color="#8492A6">SLA</AppLabel>
                                <AppText textSize="1.6" color="#101225">{data?.sla}</AppText>
                            </CustomContainer>
                        </FlexRow>
                        <CustomContainer topMargin="6">
                            <AppLabel textSize="1.4" color="#8492A6" fontWeight="500">About this dispute</AppLabel>
                            <AppText textSize="1.6" color="#101225">
                                {data?.description}
                            </AppText>
                        </CustomContainer>
                    </CustomContainer>
                    { data?.status != 'Resolved' &&
                        <FlexRow justifyContent='flex-end' topMargin="3">
                            <Button
                                width='16.4' borderColor='#E4ECF7' height='4.6'
                                hoverBgColor='#E4ECF7' hoverColor='#505780'
                                bgColor="#ffffff" color="#4C6FFF" rightMargin='1'
                                onClick={handleResolve}
                            >
                                Mark as resolved
                            </Button>
                            <Button
                                width='16.7' borderColor='#4C6FFF' height='4.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                titleSize='1.2' radius='0.6'
                                onClick={() => toggleTo('dispute-chats')}
                            >
                                Treat this dispute
                            </Button>
                        </FlexRow>
                    }
                </FlexColumn>
            </GridContainer>
        </>
    )
}